import {
  Grid,
  IconButton,
  InputBase,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import EditIcon from "@material-ui/icons/Edit";
import { EProcessNames } from "api/enums";
import clsx from "clsx";
import DialogModal from "components/UI/DialogModals";
import { lang } from "i18nLang";
import { useState } from "react";
import { AccessProfileStore, ContractRowStore, MessageStore } from "store";

const useStyles = makeStyles({
  btnExpand: { padding: 0, marginRight: 5 },
  btnEdit: { padding: 0, marginLeft: 5, display: "none" },
  iconEdit: { width: 18, height: 18 },
  descriptionContainer: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const CellEditDescription = ({ rowIndex, rowData, data }) => {
  const classes = useStyles();
  const { code, description, expanded, isStage, level } = rowData;
  const [isInput, setIsInput] = useState(false);
  const [inputValue, setInputValue] = useState(description);
  const [open, setOpen] = useState(false);

  const handleExpandClick = (index, code) => () => {
    ContractRowStore.toggleChildrenRow(index, code);
  };

  const handleEditClick = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.GERAR_CONTRATO
      ) &&
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.EDITAR_CONTRATO
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }

    setInputValue(description);
    setIsInput(true);
  };

  const handleChangeInput = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyDownInput = (ev) => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      handleBlurInput();
    }
  };

  const handleBlurInput = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setIsInput(false);
  };

  const handleConfirm = () => {
    ContractRowStore.setTablesLoading(true);
    ContractRowStore.updateRowDescription(code, inputValue)
      .then(() => {
        handleCloseModal();
      })
      .catch((error) => {
        MessageStore.error(
          lang("contract.errors.descriptionChange", error.message)
        );
      })
      .finally(() => {
        ContractRowStore.setTablesLoading(false);
      });
  };

  if (isInput) {
    return (
      <>
        <InputBase
          autoFocus={true}
          className="MuiVirtualizedTable-cell-input focused"
          name={`input-description-${rowIndex}`}
          type={"text"}
          value={inputValue}
          fullWidth
          onChange={handleChangeInput}
          onBlur={handleBlurInput}
          onKeyDown={handleKeyDownInput}
        />
        <DialogModal
          title={lang("contract.descriptionChange")}
          open={open}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          confirmLabel={lang("save")}
        >
          <Typography variant="body1">
            {lang("contract.descriptionChangeMessage")}
          </Typography>
        </DialogModal>
      </>
    );
  }

  return (
    <Grid container alignItems="center">
      {isStage && (
        <IconButton
          className={classes.btnExpand}
          onClick={handleExpandClick(rowIndex, code)}
        >
          {expanded ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
        </IconButton>
      )}
      <Tooltip title={description}>
        <div
          className={classes.descriptionContainer}
          style={{ maxWidth: `calc(100% - 55px - ${level * 0.25}rem)` }}
        >
          <Typography variant="inherit">{description}</Typography>
        </div>
      </Tooltip>
      {rowData.status !== "" && (
        <Tooltip title={lang("edit")}>
          <IconButton
            className={clsx("button-edit-description", classes.btnEdit)}
            onClick={handleEditClick}
          >
            <EditIcon className={classes.iconEdit} />
          </IconButton>
        </Tooltip>
      )}
    </Grid>
  );
};
